module.exports = __webpack_public_path__ + "img/06-resilience-redundancy.82e76d2e.png";